import * as angular from 'angular';
import { ViewportController } from '../../../../app.common/modules/common/controllers/viewport-typed.controller';


class ClickAndDeliverController extends ViewportController {
    static $inject = ['$scope', '$translate'];
    constructor(
        private $scope: ng.IScope,
        private $translate: angular.translate.ITranslateService
    ) {
        super($scope);
    }
}

angular
    .module('naut')
    .component('clickAndDeliver', {
        template: require('./clickAndDeliver.component.html'),
        controller: ClickAndDeliverController,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/clickAndDeliver/components/clickAndDeliver.component.ts